import React from 'react';

export default function ModelCardPlaceholder({ title, thumbnail }) {
  return <div className={`model-card-placeholder ${thumbnail ? 'has-thumbnail' : ''}`}>
    {thumbnail && <img src={thumbnail} alt={`Capa de ${title || 'modelo 3D'}`} />}
    <div><i className="ti ti-cube-3d-sphere" /><strong>{title || 'Modelo 3D'}</strong><span>Toque para visualizar em 3D</span></div>
  </div>;
}
